var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          directives: [
            {
              name: "smart-tooltip",
              rawName: "v-smart-tooltip",
              value: {
                show: _vm.toolTipVisible && !_vm.modalOpen,
                text: _vm.$t("regionSelector.chooseADisasterRegion"),
                position: "left",
                dark: true,
                name: "regionSelector"
              },
              expression:
                "{show: toolTipVisible && !modalOpen, text: $t('regionSelector.chooseADisasterRegion'), position: 'left', dark: true, name: 'regionSelector'}"
            }
          ],
          staticClass: "disaster-region-selector",
          attrs: {
            transition: "slide-y-transition",
            small: "",
            fab: "",
            title: _vm.$t("regionSelector.chooseADisasterRegion")
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.openModal()
            }
          }
        },
        [
          _c("img", {
            attrs: {
              width: "25px",
              src: require("../../resources/country-icon.png"),
              height: "auto"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", persistent: true },
          model: {
            value: _vm.modalOpen,
            callback: function($$v) {
              _vm.modalOpen = $$v
            },
            expression: "modalOpen"
          }
        },
        [
          _c(
            "box",
            {
              attrs: {
                background: "white",
                closable: this.localSelectedRegion !== null
              },
              on: {
                closed: function($event) {
                  return _vm.closeModal()
                }
              },
              model: {
                value: _vm.modalOpen,
                callback: function($$v) {
                  _vm.modalOpen = $$v
                },
                expression: "modalOpen"
              }
            },
            [
              _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v(_vm._s(_vm.$t("regionSelector.chooseADisasterRegion")))
              ]),
              _vm._v(" "),
              _c(
                "v-list",
                {
                  staticStyle: {
                    background: "transparent",
                    "box-shadow": "none"
                  },
                  attrs: { light: "", "three-line": "" }
                },
                _vm._l(_vm.regions, function(region, index) {
                  return _c(
                    "v-list-tile",
                    {
                      key: index,
                      attrs: {
                        color: _vm.isSelected(region) ? "primary" : "",
                        title: region.region
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.selectRegion(region)
                        }
                      }
                    },
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: { "text-transformation": "initial" },
                              attrs: {
                                icon: "",
                                fab: "",
                                round: "",
                                title: region.region
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: _vm.isSelected(region)
                                      ? "primary"
                                      : "dark"
                                  }
                                },
                                [_vm._v("done")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [
                            _vm._v(
                              "\n              " +
                                _vm._s(region.region) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-list-tile-sub-title", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("regionSelector.lastUpdate") +
                                    ": " +
                                    region.last_updated
                                ) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-569b0718", { render: render, staticRenderFns: staticRenderFns })
  }
}